import React, { useEffect, useState } from "react";
import "../css/Despachos.css"
import { Grid2, TextField, useMediaQuery, IconButton, InputAdornment, Avatar, Paper, Alert, Snackbar, Button, Dialog, DialogTitle, DialogContent, List, ListItemButton, ListItemText } from "@mui/material";
import { useTheme, width } from "@mui/system";
import { useAuth } from "../hooks/AuthProvider";
import { createSignalRConnection } from "../signalRService";

import FormData from "form-data";
import miAxios from "../api/axios";

import Confirmacion from "../components/Conformacion";
import Mensaje from "../components/Mensaje";

import SearchIcon from '@mui/icons-material/Search';
import LoginIcon from '@mui/icons-material/Login';

import Wait from "../components/Wait";

const soloNumeros = (texto) => {
    let nums = "0123456789."
    let res = ""
    for (var i = 0; i < texto.length; i++) {
        let s = texto[i]
        if (nums.indexOf(s) > -1) {
            res = res + s
        }
    }
    return res;
}

const getHoy = () => {
    const cual = new Date();
    var mm = cual.getMonth() + 1;
    var dd = cual.getDate()
    var yyyy = cual.getFullYear();
    if (mm < 10) {
        mm = '0' + mm;
    }
    if (dd < 10) {
        dd = '0' + dd;
    }
    var today = yyyy + '-' + mm + '-' + dd;
    return today;
}

// Convierte una fecha "dd/MM/yyyy" (formato de ordenes-cliente) a "yyyy-MM-dd" (requerido por el TextField type="date")
const convierteFecha = (fecha) => {
    if (!fecha) return fecha;
    const p = fecha.split("/");
    if (p.length !== 3) return fecha;
    return p[2] + "-" + p[1] + "-" + p[0];
}

export default function Despachos(props) {
    const [connection, setConnection] = useState(null);
    const [messages, setMessages] = useState([]);

    const [procesando, setProcesando] = useState(false)
    const [procesandoImg, setProcesandoImg] = useState(false)
    const [mensaje, setMensaje] = useState("")
    const [openConfirmacion, setOpenConfirmacion] = useState(false)
    const [datosMensaje, setDatosMensaje] = useState({ open: false, mensaje: "" })

    const [cedula, setCedula] = useState("")
    const [transaccionId, setTransaccionId] = useState("")
    const [transaccionFecha, setTransaccionFecha] = useState(null)
    const [photo, setPhoto] = useState(null);
    const [photo2, setPhoto2] = useState(null);

    const [ordenId, setOrdenId] = useState(0)
    const [ordenNombre, setOrdenNombre] = useState("")
    const [ordenFecha, setOrdenFecha] = useState(null)
    const [ordenMonto, setOrdenMonto] = useState("0.00")

    const [despachoFactura, setDespachoFactura] = useState("")
    const [despachoFecha, setDespachoFecha] = useState(null)
    const [despachoMonto, setDespachoMonto] = useState("0.00")
    const [despachoMontoTexto, setDespachoMontoTexto] = useState("")
    const [despachoNota, setDespachoNota] = useState("")

    const [openOrdenes, setOpenOrdenes] = useState(false)
    const [listaOrdenes, setListaOrdenes] = useState([])


    const theme = useTheme();
    const isSmall = useMediaQuery(theme.breakpoints.down('sm'));

    const user = useAuth()
    const axios = miAxios(user.handleLogout)

    useEffect(() => {
        inicio()
        
    }, [])


    const handleBuscar = async (syncCedula) => {
        blanqueaDespacho()
        let paraSync = 0;
        let buscaCedula = "";
        if (syncCedula?.length > 0) {
            buscaCedula = syncCedula
            paraSync = 1;
        } else {
            buscaCedula = cedula
        }

        if (buscaCedula.length == 0) {
            return;
        }

        setProcesando(true)

        try {
            const response = await axios.post("/despachos/inicio", {
                cedula: buscaCedula,
                sync: paraSync
            })

            const data = response.data;
            if (data.respuesta == "S") {
                setOrdenId(data.ordenId)
                setOrdenFecha(data.ordenFecha)
                setOrdenMonto(data.ordenMonto)
                setOrdenNombre(data.nombre)
                setDespachoFecha(getHoy())
                setDespachoMonto(data.ordenMonto)
                setPhoto2("https://proveedores.cooeprouasd.net/fotoview.ashx?s=" + buscaCedula)
            } else if (data.respuesta == "*") {
                // El socio tiene más de una orden con este comercio: se muestra un
                // dialog para que el proveedor elija cuál orden va a despachar.
                setOrdenId(0)
                setOrdenNombre(data.nombre)
                setPhoto2("https://proveedores.cooeprouasd.net/fotoview.ashx?s=" + buscaCedula)
                await cargarOrdenes(data.cliente)
            } else {
                setMensaje(data.mensaje)
            }
        } catch (error) {
            console.log(error)
            setMensaje(error)
        }

        setProcesando(false)
    }

    const cargarOrdenes = async (cliente) => {
        try {
            const response = await axios.get("/despachos/ordenes-cliente?cliente=" + cliente)
            const data = response.data;
            if (data.respuesta == "S") {
                setListaOrdenes(data.lista)
                setOpenOrdenes(true)
            } else {
                setMensaje(data.mensaje)
            }
        } catch (error) {
            console.log(error)
            setMensaje(error)
        }
    }

    const seleccionarOrden = (orden) => {
        setOrdenId(orden.id)
        setOrdenFecha(convierteFecha(orden.fecha))
        setOrdenMonto(orden.monto)
        setDespachoFecha(getHoy())
        setDespachoMonto(orden.monto)
        setOpenOrdenes(false)
    }

    const inicio = () => {
        setTransaccionId("(Nuevo)");
        setTransaccionFecha(getHoy())
        setOrdenId(0)
        setOrdenNombre("")
        setOrdenFecha(null)
        setOrdenMonto("0.00")

        blanqueaDespacho()
        setCedula("")
    }

    const blanqueaDespacho = async () => {
        setDespachoFactura("")
        setDespachoFecha(null)
        setDespachoMonto("0.00")
        setDespachoNota("")
        setPhoto(null)
        setPhoto2(null)
    }

    const puedeDespacho = () => {
        let resultado = true;
        if (cedula.length == 0) {
            setMensaje("Debe digitar el código del socio")
            return false;
        }
        if (parseInt(ordenId) == 0) {
            setMensaje("Debe seleccionar una orden válida")
            return false;
        }
        if (parseFloat(despachoMonto) < 1) {
            setMensaje("Debe digitar el monto de la factura")
            return false;
        }
        if (parseFloat(despachoMonto) > parseFloat(ordenMonto)) {
            setMensaje("Monto factura mayor a la orden")
            return false;
        }
        if (despachoFactura.length == 0) {
            setMensaje("Debe digitar la factura")
            return false;
        }



        return resultado;
    }

    const handleCloseMensaje = () => {
        setMensaje("")
    }

    const handleProcesar = () => {
        if (puedeDespacho()) {
            setOpenConfirmacion(true)
        }
    }

    const handleCerrarMensaje = () => {
        setDatosMensaje({ ...datosMensaje, open: false })
    }

    const temporalLogin = () => {
        user.handleLogin();
    }

    const tomaFoto = () => {
        const nUsuario = user?.usuario || 0;

        try {
            window.Android.tomaFoto(nUsuario.toString())
        } catch (error) {
            console.log("No estoy corriendo desde un dispositivo", error)
        }
    }

    const handleChangeMonto = (valor) => {
        setDespachoMontoTexto("")
        console.log(parseFloat(valor), parseFloat(ordenMonto))
        if (parseFloat(valor) > parseFloat(ordenMonto)) {
            setDespachoMontoTexto("Mayor que disponibilidad")
        }
        setDespachoMonto(valor)
    }

    const handleGrabar = () => {
        if (puedeDespacho()) {
            grabar()
        }
    }

    const grabar = async () => {
        setOpenConfirmacion(false)
        setProcesando(true)
        let params = new FormData();
        params.append("orden", ordenId);
        params.append("factura", despachoFactura);
        params.append("monto", despachoMonto);
        params.append("fecha", despachoFecha);
        params.append("nota", despachoNota);

        try {
            const response = await axios.post("/despachos/grabar", {
                orden: ordenId,
                factura: despachoFactura,
                monto: despachoMonto,
                fecha: despachoFecha,
                nota: despachoNota
            })

            const data = response.data;
            if (data.respuesta == "S") {
                window.open("/reportes/factura?id=" + ordenId, "_blank")
                inicio()
            } else {
                setMensaje(data.mensaje)
            }
        } catch (error) {
            console.log(error)
            setMensaje(error)
        }

        setProcesando(false)
    }

    return (
        <div className="Desp-cuerpo">
            <Snackbar
                open={mensaje.length == 0 ? false : true}
                autoHideDuration={6000}
                anchorOrigin={{ vertical: "top", horizontal: "center" }}
                onClose={handleCloseMensaje}
            >
                <Alert severity="error" onClose={handleCloseMensaje} variant="filled">{mensaje}</Alert>
            </Snackbar>
            <Wait procesando={procesandoImg} />
            <Wait procesando={procesando} />
            <Confirmacion open={openConfirmacion} texto={"¿Desea Despachar esta Orden?"} cancelar={() => { setOpenConfirmacion(false) }} exito={handleGrabar} />
            <Mensaje open={datosMensaje.open} cerrar={handleCerrarMensaje} texto={datosMensaje.mensaje} />

            <Dialog open={openOrdenes} onClose={() => { setOpenOrdenes(false) }}>
                <DialogTitle>Seleccione la orden a despachar</DialogTitle>
                <DialogContent dividers>
                    <List sx={{ minWidth: "280px" }}>
                        {listaOrdenes.map((orden) => (
                            <ListItemButton key={orden.id} onClick={() => { seleccionarOrden(orden) }}>
                                <ListItemText
                                    primary={"Orden #" + orden.id}
                                    secondary={orden.fecha + "  —  RD$ " + parseFloat(orden.monto).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                />
                            </ListItemButton>
                        ))}
                    </List>
                </DialogContent>
            </Dialog>

            <div className="Desp-info-tr">
                <Grid2 container spacing={1}>
                    <Grid2 size={6}>
                        <TextField
                            color="coopinfa"
                            type="text"
                            size={isSmall ? 'small' : 'large'}
                            fullWidth
                            disabled
                            InputLabelProps={{ shrink: true }}
                            value={transaccionId}
                            label="Transacción #"
                        />
                    </Grid2>
                    <Grid2 size={6} >
                        <TextField
                            type="date"
                            color="coopinfa"
                            size={isSmall ? 'small' : 'large'}
                            fullWidth
                            InputLabelProps={{ shrink: true }}
                            value={transaccionFecha}
                            label="Fecha"
                            disabled
                        />
                    </Grid2>
                </Grid2>
            </div>
            <div className="Desp-cedula">
                <TextField
                    type="text"
                    size="large"
                    color="coopinfa"
                    value={cedula}
                    slotProps={
                        {
                            input: {
                                endAdornment: <InputAdornment position="end">
                                    <IconButton onClick={handleBuscar}>
                                        <SearchIcon />
                                    </IconButton>
                                </InputAdornment>
                            }
                        }
                    }
                    fullWidth
                    InputLabelProps={{ shrink: true }}
                    label="Código"
                    onChange={(event) => { setCedula(event.target.value) }}
                />
            </div>
            <div className="Desp-foto">
                <Avatar
                    alt="Foto Socio"
                    src={photo2}
                    sx={{ width: "200px", height: "200px" }}
                />
            </div>
            <div className="Desp-foto2">
                <Paper elevation={3} sx={{ width: "100%", height: "100%", display: "grid", gridTemplateRows: "1fr 50px" }}>
                    <div style={{ overflow: "hidden", position: "relative", display: "flex", justifyContent: "center", alignItems: "center" }}>
                        <img
                            height={(isSmall ? "200px" : "340px")}
                            width={(isSmall ? "200px" : "auto")}
                            onLoad={() => { setProcesandoImg(false) }}
                            style={{ objectFit: "contain" }}
                            src={photo}
                        />
                    </div>
                    <div className="Desp-bt-foto">
                        {(isSmall ? <Button variant="contained" color="coopinfa" onClick={tomaFoto}>Foto Despacho</Button> : null)}
                    </div>
                </Paper>
            </div>
            <div className="Desp-info">
                <div className="Desp-label">
                    Datos de la orden...
                </div>
                <Grid2 container spacing={1}>
                    <Grid2 size={12}>
                        {(parseInt(ordenId) > 0 ?
                            <TextField
                                type="text"
                                color="coopinfa"
                                size={isSmall ? 'small' : 'small'}
                                fullWidth
                                value={ordenNombre}
                                label="Nombre Socio"
                                InputLabelProps={{ shrink: true }}
                                slotProps={{
                                    input: {
                                        readOnly: true,
                                    },
                                }}
                            /> : null)}
                    </Grid2>
                    <Grid2 size={6}>
                        {(parseInt(ordenId) > 0 ?
                            <TextField
                                type="text"
                                size={isSmall ? 'small' : 'small'}
                                fullWidth
                                color="coopinfa"
                                value={ordenId}
                                label="Orden Número"
                                InputLabelProps={{ shrink: true }}
                                slotProps={{
                                    input: {
                                        readOnly: true,
                                    },
                                }}
                            /> : null)}
                    </Grid2>
                    <Grid2 size={6}>
                        {(parseInt(ordenId) > 0 ?
                            <TextField
                                type="date"
                                color="coopinfa"
                                size={isSmall ? 'small' : 'small'}
                                fullWidth
                                value={ordenFecha}
                                label="Fecha"
                                InputLabelProps={{ shrink: true }}
                                slotProps={{
                                    input: {
                                        readOnly: true,
                                    },
                                }}
                            /> : null)}
                    </Grid2>
                    <Grid2 size={12} sx={{ marginTop: "10px", display: "flex", justifyContent: "center", alignItems: "center" }}>
                        {(parseInt(ordenId) > 0 ?
                            <TextField
                                type="text"
                                color="coopinfa"
                                size={isSmall ? 'small' : 'large'}
                                value={parseFloat(ordenMonto).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                label="Monto aprobado"
                                InputLabelProps={{ shrink: true }}
                                slotProps={{
                                    input: {
                                        readOnly: true,
                                    },
                                }}
                            /> : null)}
                    </Grid2>
                </Grid2>
            </div>
            <div className="Desp-despacho">
                <div className="Desp-label">
                    Despacho
                </div>
                <div className="Desp-despacho-b">
                    <div>
                        {(parseInt(ordenId) > 0 ?
                            <Grid2 container spacing={1}>
                                <Grid2 size={12} sx={{ marginBottom: "10px" }}>
                                    <TextField
                                        fullWidth
                                        sx={{ maxWidth: "200px" }}
                                        type="text"
                                        size="large"
                                        color="coopinfa"
                                        value={despachoMonto}
                                        label="Monto Despachado"
                                        InputLabelProps={{ shrink: true }}
                                        onChange={(event) => { handleChangeMonto(soloNumeros(event.target.value)) }}
                                        helperText={(despachoMontoTexto.length > 0 ? despachoMontoTexto : parseFloat(despachoMonto || "0.00").toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }))}
                                        onClick={(event) => { event.target.select() }}
                                        error={despachoMontoTexto.length > 0 ? true : false}
                                    />
                                </Grid2>
                                <Grid2 size={12} sx={{ marginBottom: "10px" }}>
                                    <TextField
                                        fullWidth
                                        color="coopinfa"
                                        sx={{ maxWidth: "200px" }}
                                        type="text"
                                        size="large"
                                        value={despachoFactura}
                                        label="Factura"
                                        InputLabelProps={{ shrink: true }}
                                        onChange={(event) => { setDespachoFactura(event.target.value) }}
                                        onClick={(event) => { event.target.select() }}
                                    />
                                </Grid2>
                                <Grid2 size={12} sx={{ marginBottom: "10px" }}>
                                    <TextField
                                        fullWidth
                                        color="coopinfa"
                                        sx={{ maxWidth: "200px" }}
                                        type="date"
                                        size="large"
                                        value={despachoFecha}
                                        label="Fecha Despacho"
                                        InputLabelProps={{ shrink: true }}
                                        onChange={(event) => { setDespachoFecha(event.target.value) }}
                                    />
                                </Grid2>
                                <Grid2 size={12} sx={{ marginBottom: "10px" }}>
                                    <TextField
                                        fullWidth
                                        type="text"
                                        color="coopinfa"
                                        size="large"
                                        multiline
                                        rows={3}
                                        value={despachoNota}
                                        label="Nota o comentario"
                                        InputLabelProps={{ shrink: true }}
                                        onChange={(event) => { setDespachoNota(event.target.value) }}
                                    />
                                </Grid2>
                            </Grid2> : null)}
                    </div>
                    <div>
                        {(parseInt(ordenId) > 0 ? <Button color="coopinfa" fullWidth variant="contained" size={isSmall ? 'small' : 'large'} sx={{ marginBottom: "10px" }} onClick={handleProcesar}>Despachar</Button> : null)}
                        <Button color="coopinfa" fullWidth variant="outlined" size={isSmall ? 'small' : 'large'} onClick={() => { inicio() }}>Cancelar</Button>
                    </div>
                </div>
            </div>
        </div>
    )
}